<template>
  <div class="content-wrapper">
    <AsideBar v-if="$route.params.name === 'DataExplorerWithDashboard'" />
    <div class="content-header">
      <div
        class="d-flex align-items-center"
        style="border-bottom: 1px solid #5c4a4a17; margin: auto !important"
      >
        <div class="row">
          <div class="col-sm-6 d-flex flex-column align-items-baseline">
            <h1 class="m-0 text-dark">Data Explorer</h1>
            <ol class="breadcrumb float-sm-left">
              <router-link
                tag="li"
                class="breadcrumb-item"
                :to="{ name: 'Home' }"
                >Home</router-link
              >
              <router-link
                tag="li"
                class="breadcrumb-item"
                :to="{ name: 'Dashboard' }"
                >Dashboard</router-link
              >
              <li class="breadcrumb-item active">Data Explorer:</li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <v-card>
      <v-data-table
        :headers="headers"
        :items="items"
        :options.sync="options"
        :loading="loading"
        :hide-default-footer="loading"
        :disable-pagination="loading"
        :server-items-length="totalLength"
        :footer-props="{
          'items-per-page-options': [25, 50, 100, 200],
          class: 'td--visualize-sticky',
        }"
        class="elevation-1 data-explorer__v-data-table"
      >
        <template v-slot:top>
          <div class="d-flex align-items-center justify-space-between">
            <v-form
              ref="form"
              v-model="isFormValid"
              lazy-validation
              class="w-100"
            >
              <div class="d-flex align-items-center mt-3">
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  :return-value="datePicker"
                  :max="maxDate"
                  transition="scale-transition"
                  offset-y
                  max-width="500px"
                  max-height="500px !important"
                  style="max-height: max-content !important"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="datePickerRangeText"
                      prepend-inner-icon="mdi-calendar"
                      readonly
                      outlined
                      dense
                      full-width
                      v-bind="attrs"
                      v-on="on"
                      :disabled="loading"
                      :loading="loading"
                      :rules="requiredRule"
                      required
                      class="px-2"
                      style="max-width: fit-content; min-width: 280px"
                    ></v-text-field>
                  </template>
                  <v-container>
                    <v-row
                      class="v-menu--container__width"
                      justify="space-around"
                      align-content="center"
                    >
                      <v-col cols="7">
                        <v-row>
                          <v-col cols="7">
                            <v-autocomplete
                              v-model="selectedTimezone"
                              :items="timezones"
                              :rules="requiredRule"
                              :disabled="loading"
                              :loading="loading"
                              class="mb-2"
                              auto-select-first
                              dense
                              outlined
                            ></v-autocomplete
                          ></v-col>
                          <v-col cols="5" class="px-0">
                            <v-autocomplete
                              v-model="selectedDateTrunc"
                              :items="[
                                {
                                  text: 'Day',
                                  value: 'day',
                                },
                                {
                                  text: 'Month',
                                  value: 'month',
                                },
                                {
                                  text: 'Year',
                                  value: 'year',
                                },
                              ]"
                              :rules="requiredRule"
                              :disabled="loading"
                              :loading="loading"
                              class="px-2"
                              auto-select-first
                              dense
                              outlined
                            >
                            </v-autocomplete>
                          </v-col>
                        </v-row>

                        <v-date-picker
                          v-model="datePicker"
                          range
                          no-title
                          scrollable
                          :min="minDate"
                          :max="maxDate"
                          :disabled="loading"
                          :loading="loading"
                        >
                          <v-spacer></v-spacer>
                          <v-btn text color="primary" @click="menu = false">
                            Cancel
                          </v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="$refs.menu.save(datePicker)"
                          >
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-col>
                      <v-col cols="3" class="py-0">
                        <v-chip-group
                          v-model="selectedDateRangePreset"
                          column
                          class="v-chip-group--width"
                        >
                          <v-chip
                            v-for="tag in [
                              'Today',
                              'Yesterday',
                              'Last 7 days',
                              'This month',
                              'Last month',
                              'Last 30 days',
                              'Last 3 months',
                              // 'Last 6 months',
                            ]"
                            :key="tag"
                            :value="tag"
                            outlined
                          >
                            {{ tag }}
                          </v-chip>
                        </v-chip-group></v-col
                      >
                    </v-row>
                  </v-container>
                </v-menu>
                <!-- <v-col cols="2">
                                    <v-autocomplete
                                        v-model="selectedSortType"
                                        label="Sort By"
                                        :items="['ASC', 'DESC']"
                                        :rules="requiredRule"
                                        :disabled="loading"
                                        :loading="loading"
                                        class="px-2"
                                        auto-select-first
                                        dense
                                        outlined
                                    >
                                    </v-autocomplete>
                                </v-col> -->
                <v-autocomplete
                  v-if="isModerRole"
                  v-model="selectedClient"
                  :items="getClients"
                  :rules="requiredRule"
                  :disabled="loading"
                  :loading="loading"
                  :search-input.sync="clientSearchValue"
                  :cache-items="true"
                  item-text="name"
                  item-value="client_uid"
                  label="Clients"
                  multiple
                  outlined
                  required
                  dense
                  class="pa-2"
                  style="max-width: fit-content; min-width: 150px"
                >
                  <template v-slot:prepend-item>
                    <v-text-field
                      v-model="clientSearchValue"
                      :loading="loading"
                      :disabled="loading"
                      outlined
                      dense
                      class="px-2 mt-5"
                    ></v-text-field>
                    <v-spacer></v-spacer>
                    <v-divider class="m-0 mb-5"></v-divider>
                    <v-checkbox
                      :input-value="areAllClientsSelected"
                      label="Select All"
                      @change="toggleClientsSelectAll"
                      color="primary"
                      class="pl-4"
                    >
                    </v-checkbox>
                    <v-divider class="m-0 mb-4"></v-divider>
                  </template>
                  <template v-slot:selection="{ item, index }">
                    <p
                      v-if="
                        index === 0 && selectedClient.length < getClients.length
                      "
                      class="text-transform--ellipsis mb-0"
                    >
                      {{ item.name }}
                    </p>
                    <span
                      v-if="
                        index === 1 &&
                        selectedClient.length !== getClients.length
                      "
                      class="m-0 p-0 grey--text text-caption v-chip__width"
                    >
                      (+
                      {{ selectedClient.length - 1 }})
                    </span>
                    <p
                      v-else-if="
                        index === 0 &&
                        selectedClient.length === getClients.length
                      "
                      class="mb-0"
                    >
                      All
                    </p>
                  </template>
                </v-autocomplete>
                <v-autocomplete
                  v-if="!isDomainDashboard"
                  v-model="selectedDomain"
                  :items="domains"
                  :rules="requiredRule"
                  :loading="loading"
                  :disabled="loading"
                  :filter="filterDomains"
                  :search-input.sync="domainSearchValue"
                  multiple
                  item-text="url"
                  item-value="website_id"
                  label="Domains"
                  outlined
                  required
                  dense
                  class="pa-2"
                  style="max-width: fit-content; min-width: 150px"
                >
                  <template v-slot:prepend-item>
                    <v-text-field
                      v-model="domainSearchValue"
                      :loading="loading"
                      :disabled="loading"
                      outlined
                      dense
                      class="px-2 mt-5"
                    ></v-text-field>
                    <v-spacer></v-spacer>
                    <v-divider class="m-0 mb-5"></v-divider>
                    <v-checkbox
                      :input-value="areAllDomainsSelected"
                      label="Select All"
                      @change="toggleDomainsSelectAll"
                      color="primary"
                      class="pl-4"
                    >
                    </v-checkbox>
                    <v-divider class="m-0 mb-4"></v-divider>
                  </template>
                  <template v-slot:selection="{ item, index }">
                    <!-- <v-chip
                                                        v-if="
                                                            index === 0 &&
                                                            selectedDomain.length <
                                                                domains.length
                                                        "
                                                    > -->
                    <p
                      v-if="
                        index === 0 && selectedDomain.length < domains.length
                      "
                      class="text-transform--ellipsis mb-0"
                    >
                      {{ item.url }}
                    </p>
                    <!-- </v-chip> -->
                    <span
                      v-if="
                        index === 1 && selectedDomain.length !== domains.length
                      "
                      class="m-0 p-0 grey--text text-caption v-chip__width"
                    >
                      (+
                      {{ selectedDomain.length - 1 }})
                    </span>
                    <p
                      v-else-if="
                        index === 0 && selectedDomain.length === domains.length
                      "
                      class="mb-0"
                    >
                      All
                    </p>
                  </template>
                </v-autocomplete>
                <v-autocomplete
                  v-model="selectedGroupBy"
                  :items="itemsToGroupBy"
                  :loading="loading"
                  :disabled="loading"
                  :rules="requiredRule"
                  label="Group By"
                  multiple
                  outlined
                  dense
                  class="pa-2"
                  style="max-width: fit-content"
                >
                  <template v-slot:prepend-item>
                    <v-checkbox
                      :input-value="areAllGroupBySelected"
                      label="Select All"
                      @change="toggleGroupBySelectAll"
                      color="primary"
                      class="pl-4"
                    >
                    </v-checkbox>
                    <v-divider class="m-0 mb-4"></v-divider>
                  </template>
                  <template v-slot:selection="{ item, index }">
                    <!-- <v-chip
                                                        v-if="
                                                            index === 0 &&
                                                            selectedDomain.length <
                                                                domains.length
                                                        "
                                                    > -->
                    <p
                      v-if="index === 0 && selectedGroupBy.length < 6"
                      class="text-transform--ellipsis mb-0 pl-1"
                    >
                      {{ item.text }}
                    </p>
                    <!-- </v-chip> -->
                    <span
                      v-if="index === 1 && selectedGroupBy.length !== 6"
                      class="m-0 p-0 grey--text text-caption v-chip__width"
                    >
                      (+
                      {{ selectedGroupBy.length - 1 }})
                    </span>
                    <p
                      v-else-if="index === 0 && selectedGroupBy.length === 6"
                      class="mb-0"
                    >
                      All
                    </p>
                  </template>
                </v-autocomplete>
                <v-checkbox
                  v-model="isWithTotalsSelected"
                  :loading="loading"
                  :disabled="loading"
                  label="With Totals"
                  class="mt-0 mb-4"
                ></v-checkbox>
              </div>
            </v-form>
            <v-spacer></v-spacer>
            <v-btn
              icon
              color="primary"
              class="mr-5 mb-5"
              :loading="loading"
              :disabled="loading"
              @click="exportData"
            >
              <v-icon>mdi-tray-arrow-down</v-icon>
            </v-btn>
            <v-btn
              color="primary"
              class="mr-3 mb-5"
              :loading="loading"
              :disabled="loading"
              @click.stop="applySettings"
              >Get Data</v-btn
            >
          </div>
        </template>
        <template v-slot:[`header.${firstHeaderValue}`]="{ header }">
          <span>
            <v-btn
              small
              icon
              color="primary"
              @click.prevent.stop="dialog = true"
              class="mr-3"
            >
              <v-icon>mdi-cog</v-icon>
            </v-btn>
            {{ header.text }}
          </span>
          <!-- <v-skeleton-loader
                        v-if="loading && items.length"
                        type="table-cell"
                    ></v-skeleton-loader>
                    <p v-else class="mb-0">{{ item.drip_id }}</p> -->
        </template>
        <template v-slot:[`item.date`]="{ item }">
          <p class="mb-0">{{ formatDate(item.date) }}</p>
        </template>
        <template v-slot:[`item.sent`]="{ item }">
          <p class="mb-0">{{ formatNumberWithCommas(item.sent) }}</p>
        </template>
        <template v-slot:[`item.delivered`]="{ item }">
          <p class="mb-0">
            {{ formatNumberWithCommas(item.delivered) }}
          </p>
        </template>
        <template v-slot:[`item.clicked`]="{ item }">
          <p class="mb-0">
            {{ formatNumberWithCommas(item.clicked) }}
          </p>
        </template>
        <template v-slot:[`item.subscribed`]="{ item }">
          <p class="mb-0">
            {{ formatNumberWithCommas(item.subscribed) }}
          </p>
        </template>
        <template v-slot:[`item.unsubscribed`]="{ item }">
          <p class="mb-0">
            {{ formatNumberWithCommas(item.unsubscribed) }}
          </p>
        </template>
        <template v-slot:[`item.sub2c`]="{ item }">
          <p class="mb-0">{{ item.sub2c ? item.sub2c + "%" : 0 }}</p>
        </template>
        <template v-slot:[`item.d2c`]="{ item }">
          <p class="mb-0">{{ item.d2c ? item.d2c + "%" : 0 }}</p>
        </template>
        <template v-slot:[`item.s2d`]="{ item }">
          <p class="mb-0">{{ item.s2d ? item.s2d + "%" : 0 }}</p>
        </template>
        <template v-slot:[`item.sub2deact`]="{ item }">
          <p class="mb-0">
            {{ item.sub2deact ? item.sub2deact + "%" : 0 }}
          </p>
        </template>
        <template v-slot:[`item.sub2uns`]="{ item }">
          <p class="mb-0">
            {{ item.sub2uns ? item.sub2uns + "%" : 0 }}
          </p>
        </template>
        <template v-slot:[`item.type`]="{ item }">
          <v-skeleton-loader
            v-if="loading && items.length"
            type="table-cell"
          ></v-skeleton-loader>
          <p v-else class="mb-0">{{ item.type }}</p>
        </template>
        <template v-slot:[`item.website_id`]="{ item }">
          <v-skeleton-loader
            v-if="loading && items.length"
            type="table-cell"
          ></v-skeleton-loader>
          <v-tooltip left v-else>
            <template v-slot:activator="{ on, attrs }">
              <span
                class="text-transform--ellipsis width-280 c-pointer"
                @click="navigateToDomainDashboard(item.website_id)"
                v-bind="attrs"
                v-on="on"
                v-if="!loading && items.length"
              >
                {{ selectedDomainWebsite(item.website_id).id }} -
                {{ selectedDomainWebsite(item.website_id).url }}
              </span>
            </template>
            <span>Click To Redirect</span>
          </v-tooltip>
        </template>
        <template v-slot:foot>
          <tfoot>
            <tr v-if="items.length && isWithTotalsSelected">
              <td class="text-bold">Totals:</td>
              <td
                v-for="(column, i) in headers"
                :key="i + column"
                class="text-bold"
                :class="{
                  'd-none': i === 0,
                  [`text-${column.align || 'center'}`]: true,
                }"
              >
                {{ getTotalsValue(column) }}
              </td>
            </tr>
          </tfoot>
          <!-- <p>
                        {{ groupedItems }}
                        {{ groupedItems({ name: "timestamp", items }) }}
                    </p> -->
        </template>
      </v-data-table>
    </v-card>

    <!-- Success Snackbar -->
    <transition
      enter-active-class="animate__animated animate__fadeIn animate__faster"
      leave-active-class="animate__animated  animate__fadeOut animate__faster"
    >
      <SuccessSnackbar
        v-if="success"
        @update-success="handleUpdateToSuccessSnackbar"
        :message="successMessage"
      />
    </transition>

    <!-- Failure Snackbar -->
    <transition
      enter-active-class="animate__animated animate__fadeIn animate__faster"
      leave-active-class="animate__animated  animate__fadeOut animate__faster"
    >
      <FailureSnackbar
        v-if="failure"
        @update-failure="handleUpdateToFailureSnackbar"
        :message="failureMessage"
      />
    </transition>

    <!-- Column Configuration Dialog -->
    <v-dialog v-model="dialog" max-width="600px">
      <v-card style="margin: 0 !important">
        <v-card-title>
          <span class="headline">Configure Table Columns</span>
          <v-spacer></v-spacer>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row
              class="justify-content-center"
              dense
              style="row-gap: 10px; column-gap: 60px"
            >
              <v-col cols="12">
                <v-checkbox
                  label="All"
                  :input-value="selectedColumns.length === allColumns.length"
                  @change="toggleColumnConfigCheckbox"
                  class="mt-0"
                ></v-checkbox>
              </v-col>

              <v-tooltip top v-for="column in allColumns" :key="column.value">
                <template v-slot:activator="{ on, attrs }">
                  <v-col
                    cols="3"
                    class="checkbox-container"
                    v-on="on"
                    v-bind="attrs"
                  >
                    <v-checkbox
                      v-model="selectedColumns"
                      :label="column.text"
                      :value="column"
                      class="px-3 mt-2 text-transform--ellipsis"
                    ></v-checkbox>
                  </v-col>
                </template>
                <span>{{ column.text }}</span>
              </v-tooltip>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="
              selectedColumns = headers;
              dialog = false;
            "
            >Cancel</v-btn
          >
          <v-btn color="primary" @click="applyColumnSettings">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
import moment from "moment";
import SuccessSnackbar from "../popUps/SuccessSnackbar.vue";
import FailureSnackbar from "../popUps/FailureSnackbar.vue";
import common from "../../mixins/common";
import { serializeObjToQueryParams } from "../../utils";
import Statistics from "../../apis/Statistics";
import { EchoService } from "../../services/EchoService";

const momentTimezone = require("moment-timezone");

export default {
  name: "DataExplorer",
  mixins: [common],
  components: {
    SuccessSnackbar,
    FailureSnackbar,
    AsideBar: () => "../websiteDash/AsideBar.vue",
  },
  data() {
    return {
      items: [],
      filters: ["Clients", "Domains", "Recurring Drips", "Welcome Drips"],
      itemsToGroupBy: [
        {
          text: "Date",
          value: "timestamp",
        },
        {
          text: "Welcome",
          value: "welcome",
        },
        {
          text: "Recurring",
          value: "recurring",
        },
        {
          text: "Domain",
          value: "website_id",
        },
        {
          text: "Drip ID",
          value: "drip_id",
        },
      ],
      allColumns: [
        {
          text: "Sent",
          value: "sent",
          sortable: true,
          align: "left",
          width: "90px",
          class: "table-header--color",
        },
        {
          text: "Deliveries",
          value: "delivered",
          sortable: true,
          align: "left",
          width: "120px",
          class: "table-header--color",
        },
        {
          text: "Clicks",
          value: "clicked",
          sortable: true,
          align: "left",
          width: "100px",
          class: "table-header--color",
        },
        {
          text: "D2C",
          value: "d2c",
          sortable: true,
          align: "left",
          width: "100px",
          class: "table-header--color",
        },
        {
          text: "S2D",
          value: "s2d",
          sortable: true,
          align: "left",
          width: "100px",
          class: "table-header--color",
        },
        {
          text: "Sub2Click",
          value: "sub2c",
          sortable: true,
          align: "left",
          width: "120px",
          class: "table-header--color",
        },
        {
          text: "Sub2Deactivated",
          value: "sub2deact",
          sortable: true,
          align: "left",
          width: "150px",
          class: "table-header--color",
        },
        {
          text: "Subs2Unsubs",
          value: "sub2uns",
          sortable: true,
          align: "left",
          width: "150px",
          class: "table-header--color",
        },
        {
          text: "Subscribed",
          value: "subscribed",
          sortable: true,
          align: "left",
          width: "120px",
          class: "table-header--color",
        },
        {
          text: "Unsubscribed",
          value: "unsubscribed",
          align: "left",
          sortable: true,
          width: "130px",
          class: "table-header--color",
        },
        {
          text: "Full Unsubscribed",
          value: "full_unsubscribed",
          sortable: true,
          align: "left",
          width: "150px",
          class: "table-header--color",
        },
        {
          text: "Deactivated",
          value: "deactivated",
          sortable: true,
          align: "left",
          width: "120px",
          class: "table-header--color",
        },
      ],
      totalItems: {},
      selectedColumns: [],

      dialog: false,
      selectedDripType: null,
      selectedDrips: null,
      selectedClient: [],
      selectedGroupBy: ["timestamp"],
      selectedFilters: null,
      selectedDomain: [],
      selectedItems: null,
      selectedTimezone: momentTimezone.tz.guess(),
      timezones: momentTimezone.tz.names(),
      loading: false,
      isSettingsDialog: false,
      clientSearchValue: "",
      domainSearchValue: "",
      isWithTotalsSelected: false,

      menu: false,
      requiredRule: [
        (v) => (Array.isArray(v) ? !!v.length : !!v || "Field is required."),
      ],
      generalGroupRule: [
        (v) =>
          (!!v.length && v.includes("client_id") && v.includes("timestamp")) ||
          "Field is required. Must include client and date group types.",
      ],
      datePicker: [
        moment().subtract(1, "weeks").format("YYYY-MM-DD"),
        moment().subtract(1, "day").format("YYYY-MM-DD"),
      ],
      selectedDateRangePreset: null,
      minDate: moment().subtract(2, "months").format("YYYY-MM-DD"),
      maxDate: moment().format("YYYY-MM-DD"),
      selectedTimezone: momentTimezone.tz.guess(),
      timezones: momentTimezone.tz.names(),

      isFormValid: false,
      success: false,
      successMessage: "",
      failure: false,
      failureMessage: "",

      headers: [],
      options: {
        page: 1,
        itemsPerPage: 50,
        sortDesc: [false],
      },
      totalLength: 0,

      selectedDateTrunc: "day",
      selectedSortType: "ASC",

      debounceTimeout: null,
    };
  },
  computed: {
    ...mapState({
      domains: (state) => state.domain.domains,
      recurringDrips: (state) => state.recurringDrip.recurringDrips,
      welcomeDrips: (state) => state.welcomeDrips.dripGroups,
      userId: (state) => state.user.user?.id,
    }),
    ...mapGetters([
      "roles",
      "getClients",
      "clientUid",
      "mapGetters",
      "selectedDomainWebsite",
      "selectedDomainById",
    ]),
    datePickerRangeText() {
      return this.datePicker.join(" ~ ");
    },
    areAllClientsSelected() {
      return this.getClients.length === this.selectedClient.length;
    },
    areAllGroupBySelected() {
      return (
        this.selectedGroupBy.length === this.itemsToGroupBy.length ||
        this.selectedGroupBy.length === 7
      );
    },
    areAllDomainsSelected() {
      return this.domains.length === this.selectedDomain.length;
    },
    firstHeaderValue() {
      return this.headers?.[0].value;
    },
    isModerRole() {
      return this.roles.includes("moder");
    },
    isDomainDashboard() {
      return !!this.$route.params?.id;
    },
  },
  created() {
    const echoInstance = new EchoService();

    echoInstance.listen("files", ".file.status-updated", (response) => {
      if (response?.status === "ready" || response?.status === "failed") {
        this.loading = false;
      }

      if (response?.status === "failed") {
        this.failureText = "Failed to generate file.";
        this.failure = true;
      }

      if (response?.status === "ready" && this.userId === response?.userId) {
        try {
          this.openTab(response.link);
        } catch (e) {
          throw new Error(e?.message || e);
        }
      }
    });
  },
  mounted() {
    this.headers = this.allColumns;
    this.selectedColumns = this.allColumns;
    this.headers[0].width = `calc(${this.headers[0].width} + 40px)`;

    if (this.isModerRole) {
      this.getAllClients();
      this.selectedGroupBy.push("client_id");
      this.itemsToGroupBy.push({
        text: "Client",
        value: "client_id",
      });
    }

    //if (!this.isModerRole && !this.domains.length) {
    this.show();
    //}
  },
  methods: {
    ...mapActions([
      "show",
      "obtainSelectedClientsDomains",
      "getAllClients",
      "obtainClientDomains",
      "getDripGroups",
      "getRecurringDrips",
      "logout",
    ]),
    getDomainsByClientUID() {
      this.loading = true;

      this.obtainClientDomains({
        headers: { client: this.selectedClient },
      });

      queueMicrotask(() => {
        this.loading = false;
      });
    },
    prepareRequestParamsToObtainChartData() {
      let params = {
        paginate: true,
        pageLength: this.options.itemsPerPage,
        page: this.options.page,
        date_start: moment(this.datePicker[0]).format("YYYY-MM-DD"),
        date_finish: moment(this.datePicker[1]).format("YYYY-MM-DD"),
        //date_trunc: this.btnClickedTitle,
        domain_ids: this.selectedDomain.toString(),
        //group_by: this.selectedGroupBy.toString(),
        timezone: this.selectedTimezone,
      };
      let headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
        client: this.selectedClient,
      };

      if (this.selectedGroupBy) {
        params.group_by = this.selectedGroupBy.toString();
      }

      return { params, headers };
    },
    applySettings() {
      let isFormValid = this.$refs.form.validate();

      if (isFormValid) {
        this.getData();
      } else {
        throw new Error("Fill the form with the required fields.");
      }
    },
    async applyColumnSettings() {
      if (!this.selectedColumns.length) {
        this.failureMessage = "There is must be at least one column selected.";
        this.failure = true;

        throw new Error("There is must be at least one column selected.");
      }

      await this.setHeaders();
      this.dialog = false;
    },
    getResponseColumnSettings() {
      let excludedColumns = this.allColumns.filter((column) => {
        return !this.selectedColumns.some((el) => el.value === column.value);
      });
      excludedColumns = excludedColumns.map((column) => column.value);
      excludedColumns = [
        ...excludedColumns,
        // "deactivated",
        // "full_unsubscribed",
        "avg_patient_days",
      ];
      // excludedColumns =
      //     this.allColumns.length === this.selectedColumns.length
      //         ? ["deactivated", "full_unsubscribed", "avg_patient_days"]
      //         : [
      //               "deactivated",
      //               "full_unsubscribed",
      //               "avg_patient_days",
      //               excludedColumns.map((column) => column.value),
      //           ];

      return {
        map: { timestamp: "date" },
        exclude: excludedColumns,
        include: this.isModerRole ? ["client"] : [],
        //select: ["type"],
      };
    },
    getTotalsValue(column) {
      if (this.totalItems[column["value"]] !== undefined) {
        let hasPercentSymbol = [
          "d2c",
          "s2d",
          "sub2uns",
          "sub2deact",
          "sub2c",
        ].includes(column["value"])
          ? "%"
          : "";

        return [
          "clicked",
          "delivered",
          "sent",
          "subscribed",
          "unsubscribed",
        ].includes(column["value"])
          ? this.formatNumberWithCommas(this.totalItems[column["value"]])
          : this.totalItems[column["value"]] + hasPercentSymbol;
      } else {
        return "";
      }
    },
    setDateRangePreset(preset) {
      const today = moment();
      let start = null;
      let end = null;

      switch (preset) {
        case "Today":
          start = today.clone().startOf("day");
          end = today;
          break;

        case "Yesterday":
          start = today.clone().subtract(1, "day").startOf("day");
          end = today.clone().subtract(1, "day").startOf("day");
          break;

        case "Last 7 days":
          start = today.clone().subtract(7, "days").startOf("day");
          end = today.clone().subtract(1, "day").startOf("day");
          break;

        case "This month":
          start = today.clone().startOf("month");
          end = today.clone().subtract(1, "day").startOf("day");
          break;

        case "Last month":
          start = today.clone().startOf("month");
          end = today.clone().subtract(1, "day").startOf("day");
          break;

        case "Last 30 days":
          start = today.clone().subtract(30, "days").startOf("day");
          end = today.clone().subtract(1, "day").startOf("day");
          break;

        case "Last 3 months":
          start = today.clone().subtract(3, "months").startOf("month");
          end = today.clone().subtract(1, "day").startOf("day");
          break;

        case "Last 6 months":
          start = today.clone().subtract(6, "months").startOf("month");
          end = today.clone().subtract(1, "day").startOf("day");
          break;

        default:
          console.error("Unknown preset:", preset);
          return;
      }

      this.datePicker = [start.format("YYYY-MM-DD"), end.format("YYYY-MM-DD")];
    },
    formatDate(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    setHeaders() {
      let valuesMapping = {
        client_id: "client",
        timestamp: "date",
        recurring: "type",
        welcome: "type",
      };

      let groupByHeaders = [
        {
          text: "Domain ID",
          value: "website_id",
          sortable: true,
          divider: true,
          width: "126px",
          class: "table-header--color-grey",
          // class: "th--visualize-sticky pr-5 table-header--color-grey border-right",
          // cellClass: "td--visualize-sticky pr-5 border-right",
        },
        {
          text: "Client",
          value: "client",
          sortable: true,
          divider: true,
          align: "center",
          width: "90px",
          class: "table-header--color-grey",
          // class: "th--visualize-sticky pr-5 table-header--color-grey border-right",
          // cellClass: "td--visualize-sticky pr-5 border-right",
        },
        {
          text: "Date",
          value: "date",
          sortable: true,
          divider: true,
          align: "center",
          width: "126px",
          class: "table-header--color-grey",
          // class: "th--visualize-sticky pr-5 table-header--color-grey border-right",
          // cellClass: "td--visualize-sticky pr-5 border-right",
        },
        {
          text: "Type",
          value: "type",
          sortable: true,
          divider: true,
          width: "90px",
          align: "left",
          class: "table-header--color-grey",
          // class: "th--visualize-sticky pr-5 table-header--color-grey border-right",
          // cellClass: "td--visualize-sticky pr-5 border-right",
        },
        {
          text: "Drip id",
          value: "drip_id",
          sortable: true,
          divider: true,
          align: "left",
          width: "90px",
          class: "table-header--color-grey",
          // class: "th--visualize-sticky pr-5 table-header--color-grey border-right",
          // cellClass: "td--visualize-sticky pr-5 border-right",
        },
      ];

      let selectedMappedGroupBy = this.selectedGroupBy.map(
        (el) => valuesMapping[el] || el
      );

      const groupByHeadersMap = new Map(
        groupByHeaders.map((header) => [header.value, header])
      );

      let selectedGroupByHeaders = Array.from(
        new Set(
          selectedMappedGroupBy
            .filter((el) => groupByHeadersMap.has(el))
            .map((el) => groupByHeadersMap.get(el))
        )
      );

      this.headers = [...selectedGroupByHeaders, ...this.selectedColumns];
      this.headers[0].width = `calc(${this.headers[0].width} + 40px)`;
    },
    splitFilters() {
      const generalFilters = [];
      const dripFilters = [];

      const filterMap = {
        general: ["client_id", "website_id", "timestamp"],
        drips: ["type", "drip_id"],
      };

      this.selectedGroupBy.forEach((filter) => {
        if (filterMap.general.includes(filter)) {
          generalFilters.push(filter);
        } else if (filterMap.drips.includes(filter)) {
          dripFilters.push(filter);
        }
      });

      generalFilters.sort();

      if (generalFilters.length === 3) {
        generalFilters.splice(1, 0, generalFilters[2]);
        generalFilters.splice(3, 1);
      }

      return { generalFilters, dripFilters };
    },
    getResponseSorting() {
      if (!this.items.length) {
        this.failureMessage = "Unable to sort due to invalid data.";
        this.failure = true;

        throw new Error("Unable to sort due to invalid data.");
      }

      let { sortBy, sortDesc } = this.options;
      let keysMapping = {
        date: "timestamp",
        client: "client_id",
      };

      return sortBy.length && sortDesc.length
        ? new Array({
            [keysMapping[sortBy[0]] || sortBy[0]]: sortDesc[0] ? "DESC" : "ASC",
          })
        : [];
    },
    async prepareRequestData() {
      const types = this.selectedGroupBy.filter(
        (el) => el === "welcome" || el === "recurring"
      );
      const columns = await this.getResponseColumnSettings();
      const orders = this.items.length ? await this.getResponseSorting() : [];
      const selectedDomains = this.isDomainDashboard
        ? new Array(this.selectedDomainById(this.$route.params.id)?.website_id)
        : this.selectedDomain;
      let params = {
        paginate: true,
        pageLength: this.options.itemsPerPage,
        page: this.options.page,
      };

      if (this.isWithTotalsSelected) {
        params["meta[]"] = "total";
      }

      if (!selectedDomains?.length || !selectedDomains) {
        throw new Error("Invalid domain website id provided.");
      }

      if (types.length && !this.selectedGroupBy.some((el) => el === "type")) {
        this.selectedGroupBy.push("type");
      } else if (!types.length) {
        this.selectedGroupBy = this.selectedGroupBy.filter(
          (el) => el !== "type"
        );
      }

      const payload = {
        timezone: this.selectedTimezone,
        date_trunc: this.selectedDateTrunc,
        columns: columns,
        filters: {
          date_start: moment(this.datePicker[0]).format("YYYY-MM-DD"),
          date_end: moment(this.datePicker[1]).format("YYYY-MM-DD"),
          website_id: this.areAllDomainsSelected ? [] : selectedDomains,
          type: types,
        },
        orders: orders,
        groups: this.selectedGroupBy.filter(
          (el) => el !== "welcome" && el !== "recurring"
        ),
      };

      if (this.isModerRole) {
        payload.filters.client_id = this.areAllClientsSelected
          ? []
          : this.selectedClient;
      } else {
        payload.filters.client_id = new Array(this.clientUid);
      }

      params = await serializeObjToQueryParams(params);

      return {
        payload,
        params,
      };
    },
    navigateToDomainDashboard(websiteId) {
      if (!websiteId) {
        throw new Error("Invalid websiteId provided.");
      }

      const selectedDomain = this.selectedDomainWebsite(websiteId)?.id || null;

      if (!selectedDomain) {
        throw new Error("Invalid selected domain provided.");
      }

      const url = this.$router.resolve({
        path: `/dashboard/${selectedDomain}`,
      }).href;
      window.open(url, "_blank");
    },
    async getData() {
      this.loading = true;

      await this.setHeaders();

      let { payload, params } = await this.prepareRequestData();
      params = params.substring(1);

      Statistics.getDataExplorer({ payload, params })
        .then((response) => {
          this.totalLength = response.data.meta.total;
          this.$set(this, "totalItems", response.data.meta.totals);
          //this.totalItems = response.data.meta.totals;
          this.items = response.data.data;
        })
        .catch((error) => {
          this.failureMessage = error?.response?.message || error;
          this.failure = true;
          throw new Error(error?.response?.message || error);
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 500);
        });
    },
    async exportData() {
      let isFormValid = this.$refs.form.validate();

      if (!this.items.length) {
        this.failureMessage =
          "No data available. Please ensure you have the required data before attempting to retrieve the file.";
        this.failure = true;
        throw new Error(
          "No data available. Please ensure you have the required data before attempting to retrieve the file."
        );
      }

      if (!isFormValid) {
        throw new Error("Fill the form with the required fields.");
      }

      this.loading = true;

      const { payload } = await this.prepareRequestData();

      Statistics.getDataExplorer({ payload, file: true })
        .catch((error) => {
          this.failureMessage = error?.response?.message || error;
          this.failure = true;
          throw new Error(error?.response?.message || error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    toggleColumnConfigCheckbox(isChecked) {
      if (isChecked) {
        this.selectedColumns = this.allColumns;
      } else {
        this.selectedColumns = [];
      }
    },
    toggleGroupBySelectAll(isChecked) {
      if (isChecked) {
        this.selectedGroupBy = this.itemsToGroupBy.map((el) => el.value);
      } else {
        this.selectedGroupBy = [];
      }
    },
    toggleClientsSelectAll(isChecked) {
      if (isChecked) {
        this.selectedClient = this.getClients.map(
          (client) => client.client_uid
        );
      } else {
        this.selectedClient = [];
      }
    },
    toggleDomainsSelectAll(isChecked) {
      if (isChecked) {
        this.selectedDomain = this.domains.map((domain) => domain.website_id);
      } else {
        this.selectedDomain = [];
      }
    },
    formatNumberWithCommas(number) {
      let convertedToNumber = new Number(number);
      return convertedToNumber.toLocaleString();
    },
    filterDomains(item, queryText, itemText) {
      if (!queryText) return true;

      return (
        itemText.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) >
          -1 ||
        item.id == queryText ||
        item.website_id == queryText
      );
    },
  },
  watch: {
    selectedDateRangePreset(preset) {
      if (preset) {
        this.setDateRangePreset(preset);
      }
    },
    selectedClient(client) {
      if (client) {
        try {
          this.selectedDomain = [];
          this.loading = true;

          clearTimeout(this.debounceTimeout);
          this.debounceTimeout = setTimeout(() => {
            this.obtainSelectedClientsDomains({
              selectedClients: client,
            }).finally(() => {
              this.loading = false;
            });
          }, 500);
        } catch (e) {
          this.failureMessage = e?.message || e;
          this.failure = true;
          throw new Error(e?.message || e);
        }
      }
    },
    options: {
      handler(options) {
        if (!this.isDomainDashboard) {
          this.applySettings();
        }
      },
      deep: true,
    },
  },
};
</script>

<style>
.checkbox-container {
  height: 56px;
  border: 2px solid #1976d282;
  border-radius: 8px;
  padding: 12px;
  background-color: #ffffff;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease-in-out;
}

.checkbox-container:hover {
  background-color: #e3f2fd;
  border-color: #1565c0;
}

.text-transform--ellipsis .v-label {
  display: block !important;
  max-width: 70px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
